import { useMutation } from 'react-query';
import axios from 'axios';

function removeSpecialCharacters(inputString) {
  const cleanedString = inputString.replace(/[^a-zA-Z0-9]/g, '');

  return cleanedString;
}

function getFileExtension(fileName) {
  return fileName.split('.').pop();
}

function getSanitizedFileName(fileName) {
  const fileExtension = getFileExtension(fileName);
  const fileNameWithoutExtension = fileName.replace(`.${fileExtension}`, '').toLowerCase();

  return removeSpecialCharacters(fileNameWithoutExtension);
}

export const useRetrieveSignedUrl = () =>
  useMutation(
    ['retrieveSignedUrl'],
    async ({ fileName, houseId }) => {
      const fileExtension = getFileExtension(fileName);
      const sanitizedFileName = getSanitizedFileName(fileName);
      const s3ObjectName =
        `${sanitizedFileName}-${new Date().getTime()}.${fileExtension}`;
      const url =
        `/kodak-api/api/v1/media/videos/signed-url/${s3ObjectName}?houseId=${houseId}&houseType=HOUSE`;
      const res = await axios.post(url, {});
      return res.data.url;
    },
    {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  );
